import React from "react";
import { useNavigate } from 'react-router-dom';
import Popup from "../../../components/Popups/Popup";
import CreateProjectView from '../../Projects/Components/CreateProject';

interface PopupProps {
    show: boolean
    onHide: () => void
}

const CreateProjectPopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const navigate = useNavigate();

    function onProjectCreated(projectId: number) {
        if (projectId) {
            navigate('/plm/Projects/Details/' + projectId);
        } else {
            if (onHide)
                onHide();
        }
    }

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Create new project'} >
            <Popup.Body>
                <CreateProjectView onProjectCreated={onProjectCreated} />
            </Popup.Body>
        </Popup>
    );
}
export default CreateProjectPopup;